<template>
  <div v-if="!!items.length" class="mb-4 d-flex align-items-center flex-wrap">
    <b-badge
      v-for="(item, key) in items"
      :key="uniqueId('base-data-table-filter-item')"
      class="text-primary border border-primary"
      pill
    >
      {{ item.label }}: {{ item.value }}

      <a
        tabIndex="0"
        class="text-danger ml-1"
        role="button"
        @click.prevent="() => removeFilter(key)"
      >
        <b-icon icon="x" :scale="1.5"></b-icon>
      </a>
    </b-badge>
  </div>
</template>

<script>
import { defineComponent, computed, inject } from '@vue/composition-api'
import { uniqueId, isArray } from 'lodash-es'

import { BaseDataTableInjectionKey } from './BaseDataTable.constants'

export default defineComponent({
  name: 'BaseDataTableFilters',
  setup() {
    const { columns, filters, removeFilter } = inject(BaseDataTableInjectionKey)

    const items = computed(() =>
      filters.value.map((filter) => {
        const column = columns.value.find((column) => column.key === filter.key)

        if (isArray(filter.value)) {
          const [dateFrom, dateTo] = filter.value

          return {
            label: `${column.label} Range`,
            value: `${dateFrom} to ${dateTo}`
          }
        } else {
          return {
            label: column.label,
            value: filter.value
          }
        }
      })
    )

    return {
      uniqueId,

      removeFilter,

      items
    }
  }
})
</script>

<style scoped>
div {
  gap: 8px;
}

div >>> .badge {
  padding: 4px 16px;
  font-size: 12px;
  font-weight: 600;
}
</style>
